import React from "react";
import IconBullets from "../../contentBlocks/IconBullets.react";
import SlideHeader from "../../contentBlocks/SlideHeader.react";
import SlideHeaderSidebar from "../../contentBlocks/SlideHeaderSidebar.react";
import PropTypes from "prop-types";
import { Grid } from "semantic-ui-react";

export default class IconList extends React.Component {
    static propTypes = {
        data: PropTypes.shape({
            title: PropTypes.string,
            subtitle: PropTypes.string,
            iconlist: PropTypes.array,
        }).isRequired,
        colors: PropTypes.shape({
            baseText: PropTypes.string,
        }).isRequired,
        slideId: PropTypes.number,
    };
    render() {
        let isPortrait =
            this.props.mobileView || window.innerHeight > window.innerWidth;
        let defaultStyle = {
            margin: "auto",
            width: isPortrait ? "80%" : "90%",
            textAlign: "left",
            padding: isPortrait ? "40px 0" : "15px",
        };
        return (
            <div className="full-height">
                {isPortrait ? (
                    <div>
                        <SlideHeader
                            {...this.props}
                            title={this.props.data.title}
                            subtitle={this.props.data.subtitle}
                        />
                        <div style={defaultStyle}>
                            <IconBullets
                                {...this.props}
                                keyName={"icon-bullets-" + this.props.slideId}
                                list={this.props.data.iconlist}
                                color={this.props.colors.baseText}
                                animation="transition.slideDownIn,600,600"
                            />
                        </div>
                    </div>
                ) : (
                    <Grid style={{ minHeight: "100%" }}>
                        <Grid.Row style={{ paddingBottom: "0" }}>
                            <Grid.Column
                                width={8}
                                style={{
                                    paddingRight: "0",
                                    background: this.props.colors.primary,
                                }}
                            >
                                <SlideHeaderSidebar
                                    {...this.props}
                                    title={this.props.data.title}
                                    subtitle={this.props.data.subtitle}
                                />
                            </Grid.Column>
                            <Grid.Column width={8} style={{ paddingLeft: "0" }}>
                                <div style={defaultStyle}>
                                    <IconBullets
                                        {...this.props}
                                        keyName={
                                            "icon-bullets-" + this.props.slideId
                                        }
                                        list={this.props.data.iconlist}
                                        color={this.props.colors.baseText}
                                        animation="transition.slideDownIn,600,600"
                                        style={{
                                            textAlign: "left",
                                        }}
                                    />
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                )}
            </div>
        );
    }
}
